export default __webpack_public_path__ + "static/media/videom.f8083edd.mp4";